module.exports = __webpack_public_path__ + "img/seting_cover.94225b9d.png";